module.exports = __webpack_public_path__ + "img/02 B_W-min.70da8714.png";